export default {
    data() {
        return {
            loading: false,
            page: 1,
            pageSize: 10,
            total: 0,
            tableData: [],
            resetTimer: null,
            table_height: 400,
            dialog_top: "15vh",
        }
    },
    computed: {
        authority() {
            return this.$route.meta.authority
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.changeTableHeight("init");
        });

        window.onresize = () => {
            this.changeTableHeight("onresize");
        };
    },
    methods: {
        // 翻页
        changePage(e) {
            this.page = e;
            this.getList();
        },
        // 表格滚动回顶部
        tableScrollTop() {
            this.$refs.table.bodyWrapper.scrollTop = 0;
        },
        // 计算表格高度
        changeTableHeight(type) {
            clearTimeout(this.resetTimer);
            this.resetTimer = setTimeout(() => {
                let height = document.getElementById('table_list').offsetHeight;
                if(type == "onresize" && this.table_height == height) return
                this.table_height = height;
                if (this.table_height < 550) {
                    this.dialog_top = "5vh";
                    this.pageSize = 10;
                } else {
                    this.dialog_top = "15vh";
                    this.pageSize = 20;
                }
                this.page = 1;
                this.getList();
            },300)
        },
    },
}


// WEBPACK FOOTER //
// ./src/mixins/index.js